module.exports = __webpack_public_path__ + "static/media/weather.56c46d80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/weather.svg
// module id = 535
// module chunks = 0